import { Flex, Text } from '@chakra-ui/react'
import React from 'react'

type FooterProps = {}

const Footer: React.FC<FooterProps> = () => {
  return (
    <Flex
      bg='blue.400'
      minH='80px'
      w='100vw'
      alignItems='center'
      p={4}
      justifyContent='space-between'
      color='black'
    >
      <Text fontSize='sm'>
        @2022 Kauhavan veteraanitalo. Kaikki oikeudet pidätetään.
      </Text>
    </Flex>
  )
}
export default Footer
